// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"259":"fbcc0bfc","521":"fbcc0bfc"}[chunkId] + ".chunk.css";
};